import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanIsDayTripRoot } from "./is-day-trip";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	dayTrip: DayTripPlanCategoriesAndManagerStore["dayTrip"];
};

export const QuestionDayTripPlanIsDayTrip = ({ dayTrip }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="日帰り" categoryStore={dayTrip}>
			<QuestionPlanIsDayTripRoot />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDayTripPlanIsDayTrip.displayName = "QuestionDayTripPlanIsDayTrip";
